import { client } from './client'
import type {
  AiProvider,
  TokenAnalyticsByModel,
  TokenAnalyticsByUser,
  TokenAnalyticsByWorkflow,
} from '@/types/analytics'

export interface AnalyticsParams {
  provider: AiProvider
  from?: string
  to?: string
}

const tokenUsageUrl = (projectId: string, view: string) =>
  `/projects/${projectId}/analytics/token-usage/${view}`

export const getTokenAnalyticsByWorkflow = (projectId: string, params: AnalyticsParams) =>
  client
    .get<TokenAnalyticsByWorkflow>(tokenUsageUrl(projectId, 'by-workflow'), { params })
    .then(res => res.data)

export const getTokenAnalyticsByUser = (projectId: string, params: AnalyticsParams) =>
  client
    .get<TokenAnalyticsByUser>(tokenUsageUrl(projectId, 'by-user'), { params })
    .then(res => res.data)

export const getTokenAnalyticsByModel = (projectId: string, params: AnalyticsParams) =>
  client
    .get<TokenAnalyticsByModel>(tokenUsageUrl(projectId, 'by-model'), { params })
    .then(res => res.data)
